$(function(){
      $(document).on('click','.u_nlpicker',function (e) {
      e.preventDefault();
    $(".u_sel_drawer_block").addClass("u_sel_drawer_active");
    $("html").addClass("u_sel_drawer_overflow");
    $('.shopify-section-group-header-group').attr('style','z-index:1 !important')
  });
    $(document).on('click','.u_sel_drawer_overlay,.nl_drawer_close',function () {
    $(".u_sel_drawer_block").removeClass("u_sel_drawer_active");
    $("html").removeClass("u_sel_drawer_overflow");
        $('.shopify-section-group-header-group').attr('style','z-index:5 ')
  });
  let i = 1;
  $(document).on('click', '.u_bundle_product', function() {
    let pre_len = $('.nl_picker_block_drawer.filled').length;
    if (pre_len >= 5) return;

    if ($(this).hasClass('selected')) return;

    let un_in = $(this).attr('data_val'); // unique id
     let bun_title = $(this).attr('data-title');
    let bun_img = $(this).attr('data_img');
     let bun_var_id = $(this).attr('data_id');

    let $emptyBox = $('.nl_picker_block_drawer')
        .not('.filled')
        .first();

    $(this)
        .addClass('selected')
        .find('.u_bundle_quantity_selector')
        .css('display', 'flex');

    if ($emptyBox.length) {
        $emptyBox
            .addClass('filled')
            .attr('data-product', un_in) // 🔥 store mapping
            .attr('var-id',bun_var_id)
            .find('.u_drawer_picker_image')
            .css("background-image", `url(${bun_img})`);
    }
//nlpicker main//
 let $emptyBox1 = $('.u_nlpicker')
        .not('.filled')
        .first();
 if ($emptyBox1.length) {
        $emptyBox1
            .addClass('filled')
            .attr('data-product', un_in) // 🔥 store mapping
            .find('.u_nl_picker_image')
            .css("background-image", `url(${bun_img})`);
 }
    
//line item
 let qty_count= $(this).find('.u_bundle_quantity_selector_input').attr('value');
  let $lineitem = $('.u_pro_line_item')
        .not('.filled')
        .first();
           if ($lineitem.length) {
        $lineitem
            .addClass('filled')
            .attr('data-count', qty_count) // 🔥 store mapping
           .val(bun_title)
    }
        let pre_len1 = $('.nl_picker_block_drawer.filled').length;
        if(pre_len1 == 5){
            $('.u_sel_butn').hide()
            $('.product-form__buttons').removeClass('u_hide_atc_btn')
        }
        else{
             $('.u_sel_butn').show()
            $('.product-form__buttons').addClass('u_hide_atc_btn')
        }
});
$(document).on('click', '.u_bundle_quantity_plus', function() {
    let $product = $(this).closest('.u_bundle_product');
    let input = $product.find('.u_bundle_quantity_selector_input');
    let count = parseInt(input.val()) || 0;
  let totalCount = $('.nl_picker_block_drawer.filled').length;
   let var_id = $product.attr('data_id')
    if (totalCount >= 5) {
        console.log('Maximum quantity reached for this product');
        return;
    }

    count++;
    input.val(count).attr('value', count);

    // 🔥 Add new preview box
    let un_in = $product.attr('data_val');
    let bun_title = $product.attr('data-title');
    let bun_img = $product.attr('data_img');

    // Find the next empty preview box
    let $emptyBox = $('.nl_picker_block_drawer').not('.filled').first();

    if ($emptyBox.length) {
        $emptyBox
            .addClass('filled')
            .attr('data-product', un_in)
               .attr('var-id',var_id)
            .find('.u_drawer_picker_image')
            .css('background-image', `url(${bun_img})`);
    }
    // nl preview
      let $emptyBox1 = $('.u_nlpicker').not('.filled').first();

    if ($emptyBox1.length) {
        $emptyBox1
            .addClass('filled')
            .attr('data-product', un_in)
            .find('.u_nl_picker_image')
            .css('background-image', `url(${bun_img})`);
    }
//line item
let qty_count= $(this).parent().find('.u_bundle_quantity_selector_input').attr('value');
  let $lineitem = $('.u_pro_line_item')
        .not('.filled')
        .first();
           if ($lineitem.length) {
        $lineitem
            .addClass('filled')
           .attr('data-count', qty_count) // 🔥 store mapping
           .val(bun_title)
    }
       let pre_len2 = $('.nl_picker_block_drawer.filled').length;
        if(pre_len2 == 5){
            $('.u_sel_butn').hide()
            $('.product-form__buttons').removeClass('u_hide_atc_btn')
        }
        else{
             $('.u_sel_butn').show()
            $('.product-form__buttons').addClass('u_hide_atc_btn')
        }
});
  $(document).on('click', '.u_bundle_quantity_minus', function(e) {

    e.stopPropagation(); // prevent re-adding

    let $product = $(this).closest('.u_bundle_product');
    let un_in = $product.attr('data_val');
  let bun_title = $product.attr('data-title');
    let bun_var_id = $(this).attr('data_id');
    let $input = $product.find('.u_bundle_quantity_selector_input');
    let count = parseInt($input.val()) || 0;

   

 

    // 🔥 remove ONLY matching preview
    let $targetBox = $('.nl_picker_block_drawer.filled')
        .filter(`[data-product="${un_in}"]`)
        .last();

    if ($targetBox.length) {
        $targetBox
            .removeClass('filled')
            .removeAttr('data-product')
             .removeAttr('var-id')
            .find('.u_drawer_picker_image')
            .css("background-image", '');
    }
    // nlpreview
        // 🔥 remove ONLY matching preview
    let $targetBox1 = $('.u_nlpicker.filled')
        .filter(`[data-product="${un_in}"]`)
        .last();

    if ($targetBox1.length) {
        $targetBox1
            .removeClass('filled')
            .removeAttr('data-product')
            .find('.u_nl_picker_image')
            .css("background-image", '');
    }

  
    
    // Remove last hidden input for Shopify
    //line item
  let qty_count= $(this).parent().find('.u_bundle_quantity_selector_input').attr('value');
console.log('qty count',qty_count)
    let $hiddenInputs = $('.u_pro_line_item').filter(`[data-count="${qty_count}"][value="${bun_title}"]`);
    if ($hiddenInputs.length) {
         $hiddenInputs.removeClass('filled');
        $hiddenInputs.attr('value',''); 
       }
          count--;
    $input.val(count).attr('value', count);
      if (count == 0) {
         $input.val(1).attr('value', 1);
        $product.removeClass('selected');
        $product.find('.u_bundle_quantity_selector').hide();
    }
       let pre_len3 = $('.nl_picker_block_drawer.filled').length;
        if(pre_len3 == 5){
            $('.u_sel_butn').hide()
            $('.product-form__buttons').removeClass('u_hide_atc_btn')
        }
        else{
             $('.u_sel_butn').show()
            $('.product-form__buttons').addClass('u_hide_atc_btn')
        }
});
//clear all selection
$(document).on('click', '.u_bundle_clear_btn', function () {

    // 🔥 1. Reset all products
    $('.u_bundle_product').each(function () {
        $(this)
            .removeClass('selected')
            .find('.u_bundle_quantity_selector')
            .hide()
            .find('.u_bundle_quantity_selector_input')
            .val(1)
            .attr('value', 1);
    });

    // 🔥 2. Clear preview boxes (drawer)
    $('.nl_picker_block_drawer').each(function () {
        $(this)
            .removeClass('filled')
            .removeAttr('data-product')
            .find('.u_drawer_picker_image')
            .css('background-image', '');
    });

    // 🔥 3. Clear NL preview
    $('.u_nlpicker').each(function () {
        $(this)
            .removeClass('filled')
            .removeAttr('data-product')
            .find('.u_nl_picker_image')
            .css('background-image', '');
    });

    // 🔥 4. Clear line items
    $('.u_pro_line_item').each(function () {
        $(this)
            .removeClass('filled')
            .removeAttr('data-count')
            .val('')
            .attr('value', '');
    });

    // 🔥 5. Reset buttons UI
    $('.u_sel_butn').show();
    let pre_len3 = $('.nl_picker_block_drawer.filled').length;
        if(pre_len3 == 5){
            $('.u_sel_butn').hide()
            $('.product-form__buttons').removeClass('u_hide_atc_btn')
        }
        else{
             $('.u_sel_butn').show()
            $('.product-form__buttons').addClass('u_hide_atc_btn')
        }

});
$(document).on('click', '.u_sell_atc_btn', function(e) {
    let ths = $(this)
    e.preventDefault();
    e.stopPropagation();

    let par_id = $(this).attr('pro_var_id');
    let proper = {};

    // Collect all selected options
    $('.u_pro_line_item.filled').each(function() {
        let name = $(this).attr('name');    // "Color 1"
        let value = $(this).val() || $(this).attr('value');
        proper[name] = value;               // plain JS object
    });

    // Parent product
    let items = [
        {
            id: par_id,
            quantity: 1,
            properties: proper   // ✅ correct format
        }
    ];

    // Add child products
    $('.nl_picker_block_drawer.filled').each(function() {
        let id = $(this).attr('var-id');
        items.push({
            id: id,
            quantity: 1,
            parent_id: par_id,
            properties: {
        '_color_product': 'true'
      }
        });
    });

    console.log('items array:', items);

    // AJAX add to cart — include sections so Shopify returns rendered HTML atomically
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRequest = cartDrawer
      ? cartDrawer.getSectionsToRender().map(function(s){ return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    var payload = {
      items: items,
      sections: sectionsToRequest,
      sections_url: window.location.pathname
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        dataType: 'json',
        beforeSend: function() {
            ths.find('button').addClass('loading');
            ths.find('.loading-overlay__spinner').removeClass('hidden');
        },
        success: function(result) {
            console.log('Added to cart:', result);
            if (!cartDrawer) { window.location.href = '/cart'; return; }
            // result.sections is returned directly by Shopify when sections are in payload
            cartDrawer.renderContents(result);
        },
        error: function(err) {
            console.error('Error adding to cart:', err);
        },
        complete: function() {
            ths.find('button').removeClass('loading');
            ths.find('.loading-overlay__spinner').addClass('hidden');
        }
    });
});
})